window.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".site-header");
  const productForm = document.querySelector(".product-single__form");

  if (!productForm) {
    return;
  }

  const sizeMq = window.matchMedia(`(min-width: 768px )`);

  let previousPosition = 0;
  const formObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const currentPosition = entry.boundingClientRect.top;
        const isScrollingUp = currentPosition < previousPosition;
        previousPosition = currentPosition;

        if (!entry.isIntersecting && isScrollingUp) {
          productForm.classList.add("is-sticky");
          if (header.classList.contains("site-header--stuck")) {
            productForm.style.setProperty(
              "--header-height",
              `${header.offsetHeight}px`
            );
          }
          return;
        }

        if (entry.isIntersecting || !isScrollingUp) {
          productForm.classList.remove("is-sticky");
        }
      });
    },
    { threshold: 0 }
  );

  sizeMq.addEventListener("change", () => {
    productForm.style.setProperty(
      "--header-height",
      `${header.offsetHeight}px`
    );
  });

  formObserver.observe(productForm);
});
